<template><home-entry /></template>
<script>
import HomeEntry from './HomeEntry.vue';
import { setPresentation } from './presentation';
export default {
  components: { HomeEntry },
  created() { setPresentation(false); }
};
</script>
